export type NumberTween = {
  from: number;
  to: number;
  startTs: number;
  durationMs: number;
  active: boolean;
};

const clamp01 = (t: number) => (t < 0 ? 0 : t > 1 ? 1 : t);

const lerp = (a: number, b: number, t: number) => a + (b - a) * t;

const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

export function initNumberTween(
  tween: NumberTween,
  value: number,
  now: number
) {
  tween.from = value;
  tween.to = value;
  tween.startTs = now;
  tween.durationMs = 0;
  tween.active = false;
}

export function sampleNumberTween(tween: NumberTween, now: number) {
  if (!tween.active || tween.durationMs <= 0) return tween.to;

  const t = clamp01((now - tween.startTs) / tween.durationMs);
  const v = lerp(tween.from, tween.to, easeOutCubic(t));

  if (t >= 1) {
    tween.active = false;
    tween.from = tween.to;
    return tween.to;
  }

  return v;
}

export function retargetNumberTween(
  tween: NumberTween,
  nextTarget: number,
  now: number,
  durationMs = 160,
  epsilon = 1e-3
) {
  const current = sampleNumberTween(tween, now);
  if (Math.abs(nextTarget - current) <= epsilon) {
    tween.from = nextTarget;
    tween.to = nextTarget;
    tween.startTs = now;
    tween.durationMs = 0;
    tween.active = false;
    return;
  }

  tween.from = current;
  tween.to = nextTarget;
  tween.startTs = now;
  tween.durationMs = durationMs;
  tween.active = true;
}
